var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expand-x-transition',[_c('div',{style:(_vm.hidden ? 'height: 0px' : (_vm.prominent ? 'height: 114px;' : ("height: " + _vm.actualHeight + ";")))})])}
var staticRenderFns = []

export { render, staticRenderFns }